import Vue from 'vue';
import firebase from 'firebase/app';
import { groupBy } from 'lodash';
import { getTimeDiff, getLocalTime } from '@qualle-admin/qutil/dist/date';
import moment from 'moment';

const state = {
  notifications: [],
  notifications_length: 0,
};

const mutations = {
  LOAD_DATA(state, data) {
    state.notifications = data;
  },
  LOAD_DATA_LENGTH(state, data) {
    state.notifications_length = data;
  },
};

const actions = {
  activeLoadData: async ({ commit, rootGetters }, orgId) => {
    try {
      Vue.prototype.$snapshots.$notifications_snapshot = firebase
        .firestore()
        .collection('notifications')
        .doc(
          `@${rootGetters['auth/get_user'].name.replace(/\s+/g, '_')}_${orgId}`
        )
        .onSnapshot((doc) => {
          const { notifications = [] } = doc.data() || [];
          const preparedNotifications = notifications.map((notification) => ({
            ...notification,
            date: getLocalTime(notification.created).format('MM/DD/YYYY'),
            originalDate: notification.created,
          }));
          const groupedNotificationsByDate = Object.values(
            groupBy(preparedNotifications, ({ date }) => date)
          );
          const preparedGroupedNotifications = groupedNotificationsByDate.map(
            (groupedNotification) => ({
              date: groupedNotification[0].date,
              notifications: groupedNotification.map(
                ({
                  created,
                  date,
                  originalDate,
                  name,
                  owner,
                  message,
                  type,
                  metadata,
                }) => ({
                  created,
                  type,
                  name,
                  date,
                  originalDate,
                  owner,
                  message,
                  metadata,
                })
              ),
            })
          );

          const preparedSortedGroupedNotifications =
            preparedGroupedNotifications
              .sort((a, b) => getTimeDiff(a.date, b.date))
              .reverse();

          const preparedFilteredGroupedNotifications =
            preparedSortedGroupedNotifications.filter(
              ({ notifications }) => notifications.length
            );

          const preparedGroupedNotificationsLength =
            preparedGroupedNotifications.reduce(
              (acc, { notifications }) => acc + notifications.length,
              0
            );

          commit('LOAD_DATA', preparedFilteredGroupedNotifications);
          commit('LOAD_DATA_LENGTH', preparedGroupedNotificationsLength);
        });
    } catch (error) {
      commit('LOAD_DATA', []);
    }
  },
  delete_notification: async ({ rootGetters, dispatch }, notificationDate) => {
    const notificationsRef = firebase
      .firestore()
      .collection('notifications')
      .doc(
        `@${rootGetters['auth/get_user'].name.replace(/\s+/g, '_')}_${
          rootGetters['auth/get_user'].orgId
        }`
      );

    const notificationsDoc = await notificationsRef.get();
    const { notifications: notificationsDocData } = notificationsDoc.data() || {
      notifications: [],
    };

    const currentNotificationIndex = notificationsDocData.findIndex(
      ({ created }) => created === notificationDate
    );

    if (currentNotificationIndex > -1) {
      notificationsDocData.splice(currentNotificationIndex, 1);

      await notificationsRef.set({
        notifications: notificationsDocData,
      });

      return dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: 'Notification deleted!',
        },
        { root: true }
      );
    }
  },
  send_notification: async ({ commit, dispatch }, payload) => {
    const { recipient, owner, type, message, metadata } = payload;
    try {
      const mentionsRef = await firebase
        .firestore()
        .collection('mentions')
        .doc(recipient);
      const notificationsRef = await firebase
        .firestore()
        .collection('notifications')
        .doc(recipient);

      const { name } = await (
        await firebase.firestore().collection('users').doc(owner).get()
      ).data();

      const mentionPayload = {
        type,
        created: moment().utc(true).format(),
        name,
        owner,
        recipient,
        title: 'New notification',
        message,
        metadata,
      };

      const notificationsPayload = [mentionPayload];

      await mentionsRef.set(mentionPayload);

      const notificationdoc = notificationsRef.get();

      if ((await notificationdoc).exists) {
        await notificationsRef.update({
          notifications: firebase.firestore.FieldValue.arrayUnion(
            ...notificationsPayload
          ),
        });
      } else {
        await notificationsRef.set({ notifications: notificationsPayload });
      }
    } catch (error) {
      console.log('error', error);
    }
  },
};

const getters = {
  get_user_notifications(state) {
    return state.notifications;
  },
  get_user_notifications_length(state) {
    return state.notifications_length;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
